'use strict';
import _ from 'lodash-es';



var hasEmptyRequired = function () {
	// filter out only the visible fields
	var requiredValues = this.$requiredInputs.filter(':visible').map(function () {
		return $(this).val();
	});
	return _(requiredValues).contains('');
};

var validateForm = function () {
	var _self = this;
	// only validate form when all required fields are filled to avoid
	// throwing errors on empty form
	if (!this.validator) {
		return;
	}

	// wait for the form to show before validating.. this applies to modals
	this.timer = setInterval(function () {
		if (_self.$form.is(':visible')) {
			if (_self.$form.find('span.error, .error-form:visible').length == 0) { //!_self.hasEmptyRequired() &&
				_self.$continue.removeAttr('disabled');
			} else {
				_self.$continue.prop('disabled', true);
			}
			clearInterval(_self.timer);
		}
	}, 100);

};

var validateEl = function (e) {
	if ($(e.target).val() === '') {
		this.$continue.prop('disabled', true);
	} else {
		// enable continue button on last required field that is valid
		// only validate single field
		if (!this.hasEmptyRequired()) {
			//this.$continue.removeAttr('disabled');
		} else {
			this.$continue.prop('disabled', true);
		}
	}
};

var checkValue = function (repopulateRequiredFields, e) {
	var $el = $(e.target);
	var attr = $el.attr('clear-on-error');

	// check for new required fields (e.g. changing US -> CH in address)
	if (repopulateRequiredFields) {
		this.$requiredInputs = this.$form.find('input.required');
	}

	// remove any error message residue from previous validation
	$el.parents('.form-row').find('.error-placement').remove();

	if (this.validator.element($el) &&
		this.$form.find('span.error').length == 0) {
		if(isContinueBtnEnabled()) {
			this.$continue.prop('disabled', false);
		}
	} else {
		this.$continue.prop('disabled', true);

		// clear the value if input has error
		if (typeof attr !== typeof undefined && attr !== false) $el.val('');
	}
};

var isContinueBtnEnabled = function (e) {
	if(Constants.IS_OOB_SESSION && $('.paymentoption-oob').length > 0 && !$(".add-edit-address-cta").is(":visible")) {
		return false;
	}
	return true;
};

var submitForm = function (e) {
	this.$form.find('input').blur();
	this.$form.find('select').blur();
	this.$form.find('.ui-selectmenu-button').blur();

	if (this.validator.numberOfInvalids() > 0 || this.$form.data('submitting') == true || $(".state .required option:selected").text() == Resources.SELECT_STATE_OPTION) {
		//    	this.$continue.prop('disabled', true);
		e.preventDefault();
		e.stopPropagation();
		return;
	}

	// adding this to prevent multiple submission of forms
	if (this.$form.attr('multiple-submission') === 'false') {
		this.$form.data('submitting', true);
	}
};

var init = function (opts, settings) {
	if (!opts.formSelector || !opts.continueSelector) {
		throw new Error('Missing form and continue action selectors.');
	}
	this.$form = $(opts.formSelector);
	this.$continue = $(opts.continueSelector);
	this.validator = settings ? this.$form.validate(settings) : this.$form.validate();
	this.$allInputs = $('input, textarea', this.$form);
	this.$allSelect = $('select', this.$form);
	this.$requiredInputs = this.$form.find('input.required');
	//    this.validateForm();

	// start listening
	//this.$requiredInputs.on('change', $.proxy(this.validateEl, this));
	this.$allInputs.on('blur', $.proxy(this.checkValue, this, false));
	this.$allSelect.on('blur', $.proxy(this.checkValue, this, true));
	this.$continue.on('click', $.proxy(this.submitForm, this));
	// [life-hack:5079] needed to trigger onclick since blur prevents the form from submitting
	if (this.$continue.attr('mousesubmit') === 'true') {
		this.$continue.on('mousedown', $.proxy(function (e) {
			this.$continue.click();
		}, this));
	}
};

var formPrepare = function () {
	return {
		$form: null,
		$continue: null,
		$allInputs: null,
		$allSelect: null,
		$requiredInputs: null,
		validator: null,
		init: init,
		timer: null,
		hasEmptyRequired: hasEmptyRequired,
		checkValue: checkValue,
		validateForm: validateForm,
		submitForm: submitForm,
		validateEl: validateEl
	}
}

export default formPrepare;